module.exports = __webpack_public_path__ + "img/mergdata_hifi_1.4488b015.png";